// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transacciones.module.css o tu hoja de estilos */
.Transacciones_tableContainer__N9QG2 {

  overflow-y: auto;
  overflow-x: auto;
}

.Transacciones_tabla__wWw0Y {
  border-collapse: collapse;
  table-layout: fixed;
  margin-bottom: 10px;
}

.Transacciones_tabla__wWw0Y th,
.Transacciones_tabla__wWw0Y td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  width: 160px;
  overflow-x: auto;
  font-size: 14px;
}

.Transacciones_tabla__wWw0Y tbody tr:nth-child(even) {
  background-color: #f2f2f2;

}
.Transacciones_containerTrans__9kLhU {
  width: 1100px;
  margin-top: 20px;
}
/* search */

.Transacciones_formSection__wykJ\\+ {
  display: flex;
  flex-wrap: nowrap;
  padding: 20px;
  justify-content: space-between;
}
.Transacciones_fechalabel__AzWNu {
  width: 400px;
}
.Transacciones_inputCVUalias__zeo5X {
  width: 400px;
}

.Transacciones_buscarAliasModal__DUQaJ {
  margin-left: 20px;
  align-items: center;
  display: flex;
  justify-content:space-evenly;
}

.Transacciones_searchInput__\\+p1Cc {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    width: 400px;
  }
  .Transacciones_searchIcon__0F6qh {
    position: absolute;
    cursor: pointer;
    right: 15px; /* Ajusta la posición izquierda del icono */
    color: #e97a20; /* Ajusta el color del icono */
    font-size: 16px; /* Ajusta el tamaño del icono */
  }
  .Transacciones_dottedHr__Gcz6Q {
  
    border-style: dotted;
    border-color: #888; 
    border-width: 1px;
    margin-left: 20px ; 
  }
.Transacciones_modal__W0Nze{
  border: none !important;

margin-left: 320px;

}
.Transacciones_Overlay__oXRAK {

}`, "",{"version":3,"sources":["webpack://./src/styles/Transacciones.module.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;;AAE3B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA,WAAW;;AAEX;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW,EAAE,2CAA2C;IACxD,cAAc,EAAE,8BAA8B;IAC9C,eAAe,EAAE,+BAA+B;EAClD;EACA;;IAEE,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;EACE,uBAAuB;;AAEzB,kBAAkB;;AAElB;AACA;;AAEA","sourcesContent":["/* Transacciones.module.css o tu hoja de estilos */\n.tableContainer {\n\n  overflow-y: auto;\n  overflow-x: auto;\n}\n\n.tabla {\n  border-collapse: collapse;\n  table-layout: fixed;\n  margin-bottom: 10px;\n}\n\n.tabla th,\n.tabla td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  width: 160px;\n  overflow-x: auto;\n  font-size: 14px;\n}\n\n.tabla tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n\n}\n.containerTrans {\n  width: 1100px;\n  margin-top: 20px;\n}\n/* search */\n\n.formSection {\n  display: flex;\n  flex-wrap: nowrap;\n  padding: 20px;\n  justify-content: space-between;\n}\n.fechalabel {\n  width: 400px;\n}\n.inputCVUalias {\n  width: 400px;\n}\n\n.buscarAliasModal {\n  margin-left: 20px;\n  align-items: center;\n  display: flex;\n  justify-content:space-evenly;\n}\n\n.searchInput {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    width: 400px;\n  }\n  .searchIcon {\n    position: absolute;\n    cursor: pointer;\n    right: 15px; /* Ajusta la posición izquierda del icono */\n    color: #e97a20; /* Ajusta el color del icono */\n    font-size: 16px; /* Ajusta el tamaño del icono */\n  }\n  .dottedHr {\n  \n    border-style: dotted;\n    border-color: #888; \n    border-width: 1px;\n    margin-left: 20px ; \n  }\n.modal{\n  border: none !important;\n\nmargin-left: 320px;\n\n}\n.Overlay {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `Transacciones_tableContainer__N9QG2`,
	"tabla": `Transacciones_tabla__wWw0Y`,
	"containerTrans": `Transacciones_containerTrans__9kLhU`,
	"formSection": `Transacciones_formSection__wykJ+`,
	"fechalabel": `Transacciones_fechalabel__AzWNu`,
	"inputCVUalias": `Transacciones_inputCVUalias__zeo5X`,
	"buscarAliasModal": `Transacciones_buscarAliasModal__DUQaJ`,
	"searchInput": `Transacciones_searchInput__+p1Cc`,
	"searchIcon": `Transacciones_searchIcon__0F6qh`,
	"dottedHr": `Transacciones_dottedHr__Gcz6Q`,
	"modal": `Transacciones_modal__W0Nze`,
	"Overlay": `Transacciones_Overlay__oXRAK`
};
export default ___CSS_LOADER_EXPORT___;
